import { Box, Typography } from '@mui/material';
import React from 'react';

const Reports: React.FC = () => {
  return (
    <Box
      sx={{
        alignItems: 'center',
        display: 'flex',
        height: '70vh',
        justifyContent: 'center',
      }}>
      <Typography variant="h5" color="textSecondary">
        Manager Reports Page - Coming Soon
      </Typography>
    </Box>
  );
};

export default Reports;
